module.exports = __webpack_public_path__ + "media/images/pic/teachers/magdalena-zak-ebd00f38e1e1763a464a75732beec49f.webp";